import { LISTAR_TRONCOS, LISTAR_TRONCO_SELECIONADO, LISTAR_ROTAS, LISTAR_TRONCO_USE, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

import TroncosHttpService from '../_services/TroncosHttpService'

export default {
  listarTroncos: async ({ commit }) => {
    try {
      const response = await TroncosHttpService.getTroncos()
      commit(LISTAR_TRONCOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  selecionarTronco: async ({ commit }, id) => {
    try {
      const response = await TroncosHttpService.getTronco(id)
      commit(LISTAR_TRONCO_SELECIONADO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTroncoUse: async({commit}, id) => {
    try{
      const response = await TroncosHttpService.getUseTronco(id)
      commit(LISTAR_TRONCO_USE, response.data)
    } catch (e){
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await TroncosHttpService.getrotas()
      commit(LISTAR_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try{
      const response = await TroncosHttpService.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, response.data)
    } catch(e) {
      console.log(e)
    }
  },
}
